import React, { useEffect, useState } from "react";
import { MdOutlineChevronLeft, MdOutlineChevronRight } from "react-icons/md";
import MainTermsBox2 from "../MainTermsBox.js/MainTermsBox2";
import MainPiecesBox2 from "../MainPiecesBox/MainPiecesBox2";
import MainSecThreeMobile from "./MainSecThreeMobile";
import {
  PIECES_LONG2,
  PIECES_MID2,
  PIECES_SHORT,
  PIECES_SHORT2,
  PIECES_TERMS2,
} from "../../../constants/pieceItems";
export default function MainSecThree() {
  const [terms, setTerms] = useState([]);
  const [pieces, setPieces] = useState([]);
  const [piecesIndex, setPiecesIndex] = useState(1);
  const [termsIndex, setTermsIndex] = useState(1);

  useEffect(() => {
    setTerms(PIECES_TERMS2);
    setPieces(PIECES_SHORT2);
  }, []);
  useEffect(() => {
    var temp = [];
    pieces.forEach((item) => {
      if (item.id == piecesIndex) {
        item.isSelect = true;
      } else {
        item.isSelect = false;
      }
      temp.push(item);
    });
    if (temp.length !== 0) {
      setPieces(temp);
    }

    var tempTerms = [];
    terms.forEach((item) => {
      if (item.id == termsIndex) {
        item.isSelect = true;
      } else {
        item.isSelect = false;
      }
      tempTerms.push(item);
    });
    if (tempTerms.length !== 0) {
      setTerms(tempTerms);
    }

    switch (termsIndex) {
      case 1: {
        setPieces(PIECES_SHORT2);
        break;
      }
      case 2: {
        setPieces(PIECES_MID2);
        break;
      }
      case 3: {
        setPieces(PIECES_LONG2);
        break;
      }
    }
  }, [termsIndex, piecesIndex, pieces]);

  const forwardPiece = () => {
    if (piecesIndex >= 8) {
      setPiecesIndex(1);
    } else {
      setPiecesIndex((prev) => prev + 1);
    }
  };
  const backwardPiece = () => {
    if (piecesIndex <= 1) {
      setPiecesIndex(8);
    } else {
      setPiecesIndex((prev) => prev - 1);
    }
  };
  return (
    <div className=" w-full  flex items-start justify-center">
      <div className="w-full max-w-[1440px]  hidden min-[769px]:flex flex-col items-center justify-start">
        <div className="relative w-[57vh] h-[12vh] mt-[150px]">
          <img
            src="../assets/images/mainPage/img_circleSigmentsUp.svg"
            className="w-[57vh] h-[12vh] "
          />
          {terms.map((item) => (
            <MainTermsBox2
              id={item.id}
              key={item.id}
              src={item.src}
              top={item.top}
              right={item.right}
              termsName={item.termsName}
              isSelect={item.isSelect}
              setTermsIndex={setTermsIndex}
            />
          ))}
        </div>
        <div className="relative w-[81vh] h-[20vh]">
          <img
            src="../assets/images/mainPage/img_circleSigmentsUp2.svg"
            className="w-[81vh] h-[20vh] "
          />
          {pieces.map((item) => (
            <MainPiecesBox2
              key={item.id}
              id={item.id}
              src={item.src}
              top={item.top}
              right={item.right}
              isSelect={item.isSelect}
              setPiecesIndex={setPiecesIndex}
            />
          ))}
        </div>

        <div className=" w-[1000px] h-[25vh] flex items-center justify-center mt-[15vh] ">
          <div className="relative w-full h-full flex flex-col items-center justify-between rounded-tl-[20px] rounded-[20px] bg-[#FFF] ">
            <div className="w-full h-1/2 flex items-center justify-end px-[40px] ">
              <div className=" w-[300px] h-full  top-[30px]  flex items-center justify-between ">
                <button
                  className="w-[40px] h-[40px] rounded-full flex items-center justify-center border-[1px] border-color-primary-D text-color-primary-D text-[28px] "
                  onClick={forwardPiece}
                >
                  <MdOutlineChevronLeft />
                </button>
                <span className="font-font_primary_A font-bold text-[35px] ">
                  {pieces.find((item) => item.id == piecesIndex)?.pieceName}
                </span>
                <button
                  className=" w-[40px] h-[40px] rounded-full flex items-center justify-center border-[1px] border-color-primary-D text-color-primary-D text-[28px]  "
                  onClick={backwardPiece}
                >
                  <MdOutlineChevronRight />
                </button>
              </div>
            </div>

            <div
              dir="rtl"
              className=" w-full h-1/2   font-font_primary_A font-medium text-[15px] text-justify px-[40px]"
            >
              <p className="">
                {pieces.find((item) => item.id == piecesIndex)?.desc}
              </p>
            </div>
          </div>
        </div>
      </div>

      <img
        src="../assets/images/other/big_polygonL.svg"
        className="hidden min-[769px]:block absolute left-[-90px] top-[500px] w-[300px] h-[280px] "
      />
      <MainSecThreeMobile />
    </div>
  );
}
